var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChargeDeclined(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 154,
    viewBox: "0 0 154 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5073_29968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 77C0 119.526 34.4741 154 77 154C119.526 154 154 119.526 154 77C154 34.4741 119.526 0 77 0C34.4741 0 0 34.4741 0 77Z",
    fill: "url(#paint0_linear_5073_29968)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.1666 116.659L27.3407 106.657C24.8389 106.155 23.2181 103.72 23.7201 101.218L29.6306 71.7753C30.1327 69.274 32.5678 67.6524 35.0695 68.1548L84.8951 78.1571C87.3968 78.6591 89.0181 81.0943 88.5156 83.596L82.6051 113.038C82.1031 115.54 79.6683 117.161 77.1666 116.659Z",
    fill: "#0B2B46"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.714 101.546H37.1891C33.9997 101.546 31.4141 98.9608 31.4141 95.7715V58.234C31.4141 55.0446 33.9997 52.459 37.1891 52.459H100.714C103.903 52.459 106.489 55.0446 106.489 58.234V95.7715C106.489 98.9608 103.903 101.546 100.714 101.546Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.714 101.546H37.1891C33.9997 101.546 31.4141 98.9608 31.4141 95.7715V58.234C31.4141 55.0446 33.9997 52.459 37.1891 52.459H100.714C103.903 52.459 106.489 55.0446 106.489 58.234V95.7715C106.489 98.9608 103.903 101.546 100.714 101.546Z",
    stroke: "#0B2B46",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.489 74.1488H31.4141V65.4863H106.489V74.1488Z",
    fill: "#0B2B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.5844 92.7807H88.8094C87.2147 92.7807 85.9219 91.4878 85.9219 89.8932V87.0057C85.9219 85.411 87.2147 84.1182 88.8094 84.1182H94.5844C96.179 84.1182 97.4719 85.411 97.4719 87.0057V89.8932C97.4719 91.4878 96.179 92.7807 94.5844 92.7807Z",
    fill: "#0B2B46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.603 103.785C129.603 116.751 119.092 127.263 106.126 127.263C93.16 127.263 82.6484 116.751 82.6484 103.785C82.6484 90.8191 93.16 80.3076 106.126 80.3076C119.092 80.3076 129.603 90.8191 129.603 103.785Z",
    fill: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.603 103.785C129.603 116.751 119.092 127.263 106.126 127.263C93.16 127.263 82.6484 116.751 82.6484 103.785C82.6484 90.8191 93.16 80.3076 106.126 80.3076C119.092 80.3076 129.603 90.8191 129.603 103.785Z",
    stroke: "white",
    strokeWidth: 2.13333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.436 96.4844L98.8359 111.085",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8359 96.4844L113.436 111.085",
    stroke: "white",
    strokeWidth: 4.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5073_29968",
    x1: 77,
    y1: 0.711483,
    x2: 77.2541,
    y2: 154.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6EBEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D7DEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F7F9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5073_29968"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 154,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChargeDeclined);
export default __webpack_public_path__ + "static/media/charge-declined.7c2cdafd264e684c7558febebb1e9612.svg";
export { ForwardRef as ReactComponent };